import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
        color: 'white',
        py: 4,
        px: { xs: 3, md: 6 },
        textAlign: 'center',
        borderTop: '2px solid rgba(255,255,255,0.1)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
          animation: 'shimmer 3s ease-in-out infinite',
        },
        '@keyframes shimmer': {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(100%)' },
        },
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h6"
            component="p"
            sx={{
              fontSize: { xs: '1rem', md: '1.1rem' },
              fontWeight: 500,
              background: 'linear-gradient(45deg, #ff6b6b, #ffffff, #ff6b6b)',
              backgroundSize: '200% 200%',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              animation: 'gradient 3s ease infinite',
              '@keyframes gradient': {
                '0%': { backgroundPosition: '0% 50%' },
                '50%': { backgroundPosition: '100% 50%' },
                '100%': { backgroundPosition: '0% 50%' },
              },
            }}
          >
          Made with ❤️ by Krishank Raghuvanshi
          </Typography>
          <Typography variant="body2" sx={{ mt: 1.5, opacity: 0.7, letterSpacing: 0.5 }}>
            Improve your resume with <a href="https://rankresu.me" target="_blank" rel="noopener noreferrer" style={{ color: '#ff6b6b', textDecoration: 'none', fontWeight: 'bold' }}>rankresu.me</a>
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Footer;
